export default __webpack_public_path__ + "static/media/home-s1-support.f108c591.png";